module.exports = __webpack_public_path__ + "fa-regular-400.47074dec01b64a5db2c40a28eb2ff267.hashedasset.woff2";